export default {
  KEVIN: '4',
  BBQ: '73e9c488-3dde-43b7-93b5-49666a123bb2',
  YAKINIKU: 'd7e2797b-a255-4f19-90a8-76760aea37c1',
  YAKINIKU_TKO: 'e12cdd54-74fc-495c-8905-267998ab1fce',
  w3: '3',
}
